import React from 'react';
import { styled } from '@mui/material';

const Counter = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 18,
  height: 18,
  borderRadius: '50%',
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  fontSize: '12px',
}));

const NewIndicator = ({ count }) => {
  if (!count) {
    return null;
  }

  return (
    <Counter>
      {count}
    </Counter>
  );
};

export default NewIndicator;
